import React from "react";
import { useUscLabel } from "../../../../utils/labels";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import type { VisualUscPriceType } from "../../../../utils/priceUtils";

type AccessoryPackMonthlyPricePropsType = {
    monthlyPrice: VisualUscPriceType | null;
};
/*
 * The monthly price for an accessory or pack will not change whenever an item is added to the basket,
 * but due to how the finance logic is set up in the reducer, it will always be set to
 * loading when the basket updates.
 * Only show a loading indicator if the accessory or pack price is not available yet.
 * If this logic ever expands, we should consider moving this to the reducer.
 */
const AccessoryPackMonthlyPrice = ({ monthlyPrice }: AccessoryPackMonthlyPricePropsType): JSX.Element | null => {
    const loadingLabel = useUscLabel("uscLoading");

    // If we failed to retrieve the monthly price, we don't want to show it.
    if (monthlyPrice?.monthlyFailed) {
        return null;
    }

    // Formatted price -> display it
    if (monthlyPrice?.monthlyPriceFormatted) {
        return (
            <Text tag="div" variant="body-book" color="grey-7">
                <span dangerouslySetInnerHTML={{ __html: monthlyPrice.monthlyPriceFormatted }} />
            </Text>
        );
    }

    // If price is loading or accessory/pack price is not available yet, show loading
    if (monthlyPrice?.monthlyLoading || !monthlyPrice) {
        return (
            <Text tag="div" variant="body-book" color="grey-7">
                {loadingLabel}
            </Text>
        );
    }

    return null;
};

export default AccessoryPackMonthlyPrice;
